import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./Container.module.css";
import clsx from "clsx";
export const Container = _ref => {
  let {
    children,
    layoutClassName
  } = _ref;
  return _jsx("div", {
    className: clsx(styles.container, [layoutClassName && layoutClassName]),
    children: children
  });
};